document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".js-autoplay-video");

  videos.forEach((video) => {
    const wrapper = video.closest(".alt-text-with-icons__block-video");

    if (!wrapper) return;

    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    const showVideo = () => {
      wrapper.classList.add("is-video-playing");
    };

    const hideVideo = () => {
      wrapper.classList.remove("is-video-playing");
    };

    const tryPlay = () => {
      const playPromise = video.play();

      if (playPromise && typeof playPromise.then === "function") {
        playPromise.then(showVideo).catch(hideVideo);
      }

      setTimeout(() => {
        if (video.paused || video.readyState < 2) {
          hideVideo();
        }
      }, 1200);
    };

    video.addEventListener("playing", showVideo);
    video.addEventListener("pause", hideVideo);
    video.addEventListener("error", hideVideo);

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener("loadeddata", tryPlay, { once: true });
    }
  });
});
